import React from 'react';
import { Helmet } from 'react-helmet-async';

interface NoIndexWrapperProps {
  children: React.ReactNode;
}

const NoIndexWrapper: React.FC<NoIndexWrapperProps> = ({ children }) => (
  <>
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    {children}
  </>
);

export default NoIndexWrapper;
